import React, { useState, useEffect, useCallback, useRef } from 'react';
import html2pdf from "html2pdf.js";
import axios from "axios";
import { onsiteAPI, onsiteUtils ,BASE_URL, serviceApi } from './api';
import { useNavigate } from 'react-router-dom';
import * as pdfjsLib from "pdfjs-dist/build/pdf";
import { GlobalWorkerOptions, getDocument } from 'pdfjs-dist';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.js';
import QRCode from 'qrcode';
import { BrowserQRCodeReader } from '@zxing/library';




const OnsiteDashboard = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeMenuItem, setActiveMenuItem] = useState('dashboard');
  const [selectedCamp, setSelectedCamp] = useState(null);
  const [patients, setPatients] = useState([]);
  const [originalPatients, setOriginalPatients] = useState([]);
  const [loadingPatients, setLoadingPatients] = useState(false);
  const [packages, setPackages] = useState([]);
  const [loadingPackages, setLoadingPackages] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [photoFile, setPhotoFile] = useState(null);
  const [idFile, setIdFile] = useState(null);
  const [loanFile, setLoanFile] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedDetailPatient, setSelectedDetailPatient] = useState(null);
  const [showEditPatientModal, setShowEditPatientModal] = useState(false);
  const [editingPatient, setEditingPatient] = useState(null);
  const [useFrontCamera, setUseFrontCamera] = useState(true);
  const [editForm, setEditForm] = useState({
    patient_name: '',
    age: '',
    gender: '',
    contact_number: '',
    loan_account_number: '',
    aadhar_number: '',
    services: []
  });
  const [isEditing, setIsEditing] = useState(false);

  const [availableServices, setAvailableServices] = useState([]);
  const [loadingServices, setLoadingServices] = useState(false);

  // Add these new state variables after line 17
  const [showAddPatientModal, setShowAddPatientModal] = useState(false);
  const [patientForm, setPatientForm] = useState({
    patient_id: '',
    name: '',
    age: '',
    gender: '',
    phone: '',
    services: [],
    load_number: ''
  });
  const [isSubmittingPatient, setIsSubmittingPatient] = useState(false);

  // NEW: Add states for QR and Photo scanning
  const [showQRScanModal, setShowQRScanModal] = useState(false);
  const [showPhotoScanModal, setShowPhotoScanModal] = useState(false);
  const [scanResult, setScanResult] = useState(null);
  const [isScanning, setIsScanning] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);
  const qrReaderRef = useRef(null);
  // Camera readiness state - ensures video metadata/frames are available before capture
  const [isCameraReady, setIsCameraReady] = useState(false);

  // Color constants
  const COLORS = {
    white: '#ffffff',
    success: '#16a34a',
    danger: '#dc2626',
    lightGrey: '#f8f9fa',
    mediumGrey: '#e1e5e9',
    darkGrey: '#6c757d',
    lightText: '#8e9aaf',
    mediumText: '#6b7280',
    darkText: '#1f2937',
    aquaBlue: '#17a2b8',
    orange: '#f97316' 
  };



  const fetchAvailableServices = async () => {
    setLoadingServices(true);
    try {
      const response = await axios.get(`${BASE_URL}/api/services/`);
      setAvailableServices(response.data);
    } catch (error) {
      console.error('Error fetching services:', error);
      setAvailableServices([]);
    } finally {
      setLoadingServices(false);
    }
  };

  // NEW: Camera and scanning functions
const startCamera = async () => {
  try {
    setIsCameraReady(false);
    const stream = await navigator.mediaDevices.getUserMedia({
      video: { 
        facingMode: 'user',
        facingMode: 'environment',
        width: { ideal: 1280 },
        height: { ideal: 720 }
      }
    });
    
    if (videoRef.current) {
      videoRef.current.srcObject = stream;
      streamRef.current = stream;

      // Wait for video to be ready
      const onLoadedMetadata = () => {
        console.log('Video metadata loaded:', {
          videoWidth: videoRef.current.videoWidth,
          videoHeight: videoRef.current.videoHeight
        });
        
        // Try to play
        videoRef.current.play()
          .then(() => {
            console.log('Video playing');
            // Wait a bit more to ensure frames are rendering
            setTimeout(() => {
              setIsCameraReady(true);
              console.log('Camera ready');
            }, 300);
          })
          .catch(err => {
            console.warn('Video play error:', err);
            setIsCameraReady(true); // Try anyway
          });
      };

      videoRef.current.addEventListener('loadedmetadata', onLoadedMetadata, { once: true });
      
      // Fallback timeout
      setTimeout(() => {
        if (!isCameraReady && videoRef.current?.videoWidth > 0) {
          console.log('Camera ready via fallback');
          setIsCameraReady(true);
        }
      }, 1500);
    }
  } catch (error) {
    console.error('Error accessing camera:', error);
    alert('Unable to access camera. Please check permissions.');
  }
};

  const stopCamera = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
      streamRef.current = null;
    }
    try {
      if (videoRef.current) {
        try { videoRef.current.pause(); } catch(e) {}
        try { videoRef.current.srcObject = null; } catch(e) {}
      }
    } catch(e) {
      console.warn('stopCamera: error while cleaning video element', e);
    }
    setIsCameraReady(false);
  };

  useEffect(() => {
    return () => {
      stopCamera();
      stopQRScanner();
    };
  }, []);

const startQRScanner = async () => {
  try {
    if (!videoRef.current) {
      console.error('videoRef not ready');
      return;
    }

    const codeReader = new BrowserQRCodeReader();
    qrReaderRef.current = codeReader;

  const stopCamera = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
      streamRef.current = null;
    }
    try {
      if (videoRef.current) {
        try { videoRef.current.pause(); } catch(e) {}
        try { videoRef.current.srcObject = null; } catch(e) {}
      }
    } catch(e) {
      console.warn('stopCamera: error while cleaning video element', e);
    }
    setIsCameraReady(false);
  };

  const startQRScanner = async () => {
  try {
    const codeReader = new BrowserQRCodeReader();
    qrReaderRef.current = codeReader;

    await codeReader.decodeFromVideoDevice(null, videoRef.current, async (result, err) => {
      if (result) {
        // Auto-detected a QR code — stop scanning immediately
        stopQRScanner();
        setIsScanning(false);

        try {
          const response = await axios.post(`${BASE_URL}/api/campmanager/scan`, {
            image: result.getText() // send the decoded QR text directly
          });
          setScanResult(response.data);
        } catch (error) {
          console.error('Error from scan API:', error);
          alert(`Error: ${error.response?.data?.message || error.response?.data?.error || 'Failed to scan'}`);
          setIsScanning(true);
          startQRScanner(); // restart scanning if API fails
        }
      }
      // if err, it just means no QR found in that frame — loop continues automatically
    });
  } catch (error) {
    console.error('QR Scanner error:', error);
    alert('Unable to start QR scanner.');
  }
};

const stopQRScanner = () => {
  if (qrReaderRef.current) {
    qrReaderRef.current.reset();
    qrReaderRef.current = null;
  }
};

const handleQRScanClick = () => {
  setShowQRScanModal(true);
  setScanResult(null);
  setIsScanning(true);
  setTimeout(() => startQRScanner(), 300);
};

  const handlePhotoScanClick = () => {
    setShowPhotoScanModal(true);
    setScanResult(null);
    setTimeout(() => startCamera(), 100);
  };

  const capturePhoto = () => {
    if (!videoRef.current || !canvasRef.current) return;

    const video = videoRef.current;
    const canvas = canvasRef.current;
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const context = canvas.getContext('2d');
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    return canvas.toDataURL('image/jpeg');
  };

 // UPDATED handleCapture function - Replace your existing one with this:

// Helper: convert Blob to dataURL
const blobToDataURL = (blob) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onerror = reject;
  reader.onloadend = () => resolve(reader.result);
  reader.readAsDataURL(blob);
});

const capturePhotoBlob = () => new Promise(async (resolve, reject) => {
  if (!videoRef.current || !canvasRef.current) {
    console.error('capturePhotoBlob: missing videoRef or canvasRef', { 
      videoRef: !!videoRef.current, 
      canvasRef: !!canvasRef.current 
    });
    return reject(new Error('Video or canvas not ready'));
  }

  const video = videoRef.current;
  const canvas = canvasRef.current;

  // Wait for video dimensions with retry logic
  let attempts = 0;
  const maxAttempts = 20; // Increased to 2 seconds
  
  while ((!video.videoWidth || !video.videoHeight) && attempts < maxAttempts) {
    await new Promise(r => setTimeout(r, 100));
    attempts += 1;
  }

  let width = video.videoWidth || video.clientWidth || 0;
  let height = video.videoHeight || video.clientHeight || 0;

  if (!width || !height) {
    console.error('capturePhotoBlob: video dimensions not available after wait', {
      videoWidth: video.videoWidth,
      videoHeight: video.videoHeight,
      clientWidth: video.clientWidth,
      clientHeight: video.clientHeight,
      readyState: video.readyState,
      attempts
    });
    return reject(new Error('Video or canvas not ready'));
  }

  console.log('Capturing photo with dimensions:', { width, height });

  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  
  try {
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
  } catch (drawErr) {
    console.error('capturePhotoBlob: drawImage failed', drawErr);
    return reject(new Error('Failed to capture frame'));
  }

  canvas.toBlob((blob) => {
    if (blob) {
      console.log('Blob created successfully:', { size: blob.size, type: blob.type });
      resolve(blob);
    } else {
      reject(new Error('Canvas toBlob returned null'));
    }
  }, 'image/jpeg', 0.95);
});

const handleCapture = async () => {
  setIsScanning(true);
  try {
    // Add a small delay to ensure video is rendering
    await new Promise(resolve => setTimeout(resolve, 100));
    
    // Capture to blob directly to avoid fetching data URLs
    const blob = await capturePhotoBlob();
    console.log('Blob info before upload:', { type: blob.type, size: blob.size });

    // Sanity check: ensure blob doesn't contain HTML (some flows may return an HTML error page)
    let blobTextPreview = '';
    try {
      blobTextPreview = (await blob.text()).slice(0,200);
    } catch (e) {
      console.warn('Could not read blob as text (likely binary):', e);
    }

    if ((blob.type && !blob.type.startsWith('image/')) || /<\!DOCTYPE|<html|<html\s/i.test(blobTextPreview)) {
      console.error('Captured blob appears to be non-image. blob.type:', blob.type, 'preview:', blobTextPreview.slice(0,120));
      alert('Captured data appears invalid (not an image). Check camera and try again.');
      setIsScanning(false);
      return;
    }

    if (showQRScanModal) {
      // QR Scan API call - convert blob to dataURL
      const dataURL = await blobToDataURL(blob);
      const response = await axios.post(`${BASE_URL}/api/campmanager/scan`, {
        image: dataURL
      });
      setScanResult(response.data);
    } else if (showPhotoScanModal) {
      // Photo Scan API call - needs FormData with file and camp_id
      const formData = new FormData();
      // Convert blob to File to ensure proper MIME/type when sent
      const file = new File([blob], 'patient_photo.jpg', { type: blob.type || 'image/jpeg' });
      formData.append('photo', file);
      
      // Add camp_id if available
      if (selectedCamp?.id) {
        formData.append('camp_id', String(selectedCamp.id));
      }

      // Debug: print form data entries
      for (const [key, value] of formData.entries()) {
        console.log('formData entry:', key, value);
      }
      
      // Let browser/axios set Content-Type (with boundary) automatically
      const response = await axios.post(`${BASE_URL}/api/campmanager/verify-patient/`, formData);
      setScanResult(response.data);
    }
    
    stopCamera();
  } catch (error) {
    console.error('Error scanning:', error);
    alert(`Error: ${error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to scan'}`);
  } finally {
    setIsScanning(false);
  }
};
/* 
KEY CHANGES:
1. Convert base64 image to Blob using fetch()
2. For Photo Scan: Use FormData instead of JSON
3. Append 'photo' as file and 'camp_id' as field
4. Set proper Content-Type header for multipart/form-data
5. Better error handling to show API error messages

This matches the Django backend expectation:
- camp_id = request.data.get("camp_id")
- photo = request.FILES.get("photo")
*/

  const handleVerifyAndPrint = async () => {
    if (!scanResult) return;

    setIsVerifying(true);
    try {
      const response = await axios.post(`${BASE_URL}/api/campmanager/print-thermal-slips/`, {
        patient_ids: [scanResult.patient_id || scanResult.id]
      });
      
      alert('Thermal slip printed successfully!');
      handleCloseScanModal();
      
      // Refresh patient list
      if (selectedCamp && selectedPackage) {
        await fetchPackagePatients(selectedCamp.id, selectedPackage.id);
      }
    } catch (error) {
      console.error('Error printing thermal slip:', error);
      alert(`Error: ${error.response?.data?.message || 'Failed to print'}`);
    } finally {
      setIsVerifying(false);
    }
  };

const handleCloseScanModal = () => {
  stopCamera();
  stopQRScanner();
  setShowQRScanModal(false);
  setShowPhotoScanModal(false);
  setScanResult(null);
  setIsScanning(false);
};

  // Clean up camera on unmount
// useEffect(() => {
//   return () => {
//     stopCamera();
//     stopQRScanner();
//   };
// }, []);

    let deviceId = undefined;
    try {
      const tempStream = await navigator.mediaDevices.getUserMedia({ video: true });
      tempStream.getTracks().forEach(t => t.stop());
    
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoDevices = devices.filter(d => d.kind === 'videoinput');
      
      console.log('Available cameras:', videoDevices.map(d => d.label));
    
      if (useFrontCamera) {
        const front = videoDevices.find(d =>
          d.label.toLowerCase().includes('front') ||
          d.label.toLowerCase().includes('user')
        ) || videoDevices[videoDevices.length - 1]; // last = front on Android
        deviceId = front?.deviceId;
      } else {
        const back = videoDevices.find(d =>
          d.label.toLowerCase().includes('back') ||
          d.label.toLowerCase().includes('rear') ||
          d.label.toLowerCase().includes('environment')
        ) || videoDevices[0]; // first = back on Android
        deviceId = back?.deviceId;
      }
      
      console.log('Using camera:', useFrontCamera ? 'front' : 'back', deviceId);
    } catch (e) {
      console.warn('Device lookup failed:', e);
    }  

    // Let zxing handle camera access via the video element directly
    codeReader.decodeFromVideoDevice(
      deviceId,       // undefined = use default camera
      videoRef.current, // attach to your video element
      async (result, err) => {
        if (result) {
          // Guard: prevent double-fire
          if (!qrReaderRef.current) return;

          console.log('QR detected:', result.getText());
          
          // Capture reader instance and clear ref to prevent double-fire
          const reader = qrReaderRef.current;
          qrReaderRef.current = null;

          try {
            // Capture the current video frame BEFORE stopping the scanner
            const video = videoRef.current;
            if (!video || !video.videoWidth) {
              alert('Camera not ready, please try again');
              try { reader.reset(); } catch(e) {}
              setIsScanning(false);
              return;
            }

            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            canvas.getContext('2d').drawImage(video, 0, 0);

            // Stop scanner after capture
            try { reader.reset(); } catch(e) { console.warn('Stop scanner error:', e); }
            setIsScanning(false);

            const blob = await new Promise((resolve) =>
              canvas.toBlob(resolve, 'image/jpeg', 0.95)
            );

            const formData = new FormData();
            formData.append('boarding_pass_image', blob, 'qr_scan.jpg');

            const response = await axios.post(
              `${BASE_URL}api/campmanager/boardingpass/scan/`,
              formData
            );

            setScanResult(response.data);

          } catch (error) {
            console.error('API error after QR detect:', error);
            alert(`Error: ${error.response?.data?.message || error.response?.data?.error || 'Failed to scan'}`);
            setIsScanning(false);
            // Ensure reader is reset if error occurred
            try { reader.reset(); } catch(e) {}
          }
        }
        // err here just means "no QR in this frame" — ignore it
      }
    );

  } catch (error) {
    console.error('QR Scanner failed to start:', error);
    alert('Unable to start QR scanner. Check camera permissions.');
    setIsScanning(false);
  }
};

const stopQRScanner = () => {
  if (qrReaderRef.current) {
    try {
      qrReaderRef.current.reset();
    } catch(e) {
      console.warn('stopQRScanner error:', e);
    }
    qrReaderRef.current = null;
  }
};

const handleQRScanClick = () => {
  setShowQRScanModal(true);
  setScanResult(null);
  setIsScanning(true);
  // Give modal time to mount, then start
  setTimeout(() => startQRScanner(), 500);
};

  const handlePhotoScanClick = () => {
    setShowPhotoScanModal(true);
    setScanResult(null);
    setTimeout(() => startCamera(), 100);
  };

  const capturePhoto = () => {
    if (!videoRef.current || !canvasRef.current) return;

    const video = videoRef.current;
    const canvas = canvasRef.current;
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const context = canvas.getContext('2d');
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    return canvas.toDataURL('image/jpeg');
  };

 // UPDATED handleCapture function - Replace your existing one with this:

// Helper: convert Blob to dataURL
const blobToDataURL = (blob) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onerror = reject;
  reader.onloadend = () => resolve(reader.result);
  reader.readAsDataURL(blob);
});

const capturePhotoBlob = () => new Promise(async (resolve, reject) => {
  if (!videoRef.current || !canvasRef.current) {
    console.error('capturePhotoBlob: missing videoRef or canvasRef', { 
      videoRef: !!videoRef.current, 
      canvasRef: !!canvasRef.current 
    });
    return reject(new Error('Video or canvas not ready'));
  }

  const video = videoRef.current;
  const canvas = canvasRef.current;

  // Wait for video dimensions with retry logic
  let attempts = 0;
  const maxAttempts = 20; // Increased to 2 seconds
  
  while ((!video.videoWidth || !video.videoHeight) && attempts < maxAttempts) {
    await new Promise(r => setTimeout(r, 100));
    attempts += 1;
  }

  let width = video.videoWidth || video.clientWidth || 0;
  let height = video.videoHeight || video.clientHeight || 0;

  if (!width || !height) {
    console.error('capturePhotoBlob: video dimensions not available after wait', {
      videoWidth: video.videoWidth,
      videoHeight: video.videoHeight,
      clientWidth: video.clientWidth,
      clientHeight: video.clientHeight,
      readyState: video.readyState,
      attempts
    });
    return reject(new Error('Video or canvas not ready'));
  }

  console.log('Capturing photo with dimensions:', { width, height });

  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  
  try {
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
  } catch (drawErr) {
    console.error('capturePhotoBlob: drawImage failed', drawErr);
    return reject(new Error('Failed to capture frame'));
  }

  canvas.toBlob((blob) => {
    if (blob) {
      console.log('Blob created successfully:', { size: blob.size, type: blob.type });
      resolve(blob);
    } else {
      reject(new Error('Canvas toBlob returned null'));
    }
  }, 'image/jpeg', 0.95);
});

const handleCapture = async () => {
  setIsScanning(true);
  try {
    // Add a small delay to ensure video is rendering
    await new Promise(resolve => setTimeout(resolve, 100));
    
    // Capture to blob directly to avoid fetching data URLs
    const blob = await capturePhotoBlob();
    console.log('Blob info before upload:', { type: blob.type, size: blob.size });

    // Sanity check: ensure blob doesn't contain HTML (some flows may return an HTML error page)
    let blobTextPreview = '';
    try {
      blobTextPreview = (await blob.text()).slice(0,200);
    } catch (e) {
      console.warn('Could not read blob as text (likely binary):', e);
    }

    if ((blob.type && !blob.type.startsWith('image/')) || /<\!DOCTYPE|<html|<html\s/i.test(blobTextPreview)) {
      console.error('Captured blob appears to be non-image. blob.type:', blob.type, 'preview:', blobTextPreview.slice(0,120));
      alert('Captured data appears invalid (not an image). Check camera and try again.');
      setIsScanning(false);
      return;
    }

    if (showQRScanModal) {
      // QR Scan API call - convert blob to dataURL
      const dataURL = await blobToDataURL(blob);
      const response = await axios.post(`${BASE_URL}/api/campmanager/scan`, {
        image: dataURL
      });
      setScanResult(response.data);
    } else if (showPhotoScanModal) {
      // Photo Scan API call - needs FormData with file and camp_id
      const formData = new FormData();
      // Convert blob to File to ensure proper MIME/type when sent
      const file = new File([blob], 'patient_photo.jpg', { type: blob.type || 'image/jpeg' });
      formData.append('photo', file);
      
      // Add camp_id if available
      if (selectedCamp?.id) {
        formData.append('camp_id', String(selectedCamp.id));
      }

      // Debug: print form data entries
      for (const [key, value] of formData.entries()) {
        console.log('formData entry:', key, value);
      }
      
      // Let browser/axios set Content-Type (with boundary) automatically
      const response = await axios.post(`${BASE_URL}/api/campmanager/verify-patient/`, formData);
      setScanResult(response.data);
    }
    
    stopCamera();
  } catch (error) {
    console.error('Error scanning:', error);
    alert(`Error: ${error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to scan'}`);
  } finally {
    setIsScanning(false);
  }
};
/* 
KEY CHANGES:
1. Convert base64 image to Blob using fetch()
2. For Photo Scan: Use FormData instead of JSON
3. Append 'photo' as file and 'camp_id' as field
4. Set proper Content-Type header for multipart/form-data
5. Better error handling to show API error messages

This matches the Django backend expectation:
- camp_id = request.data.get("camp_id")
- photo = request.FILES.get("photo")
*/

  const handleVerifyAndPrint = async () => {
    if (!scanResult) return;

    setIsVerifying(true);
    try {
      const response = await axios.post(`${BASE_URL}api/campmanager/print-thermal-slips/`, {
        patient_ids: [scanResult.patient_id || scanResult.id]
      });
      
      alert('Thermal slip printed successfully!');
      handleCloseScanModal();
      
      // Refresh patient list
      if (selectedCamp && selectedPackage) {
        await fetchPackagePatients(selectedCamp.id, selectedPackage.id);
      }
    } catch (error) {
      console.error('Error printing thermal slip:', error);
      alert(`Error: ${error.response?.data?.message || 'Failed to print'}`);
    } finally {
      setIsVerifying(false);
    }
  };

const handleCloseScanModal = () => {
  stopCamera();
  stopQRScanner();
  setShowQRScanModal(false);
  setShowPhotoScanModal(false);
  setScanResult(null);
  setIsScanning(false);
};

  // Clean up camera on unmount
useEffect(() => {
  return () => {
    stopCamera();
    stopQRScanner();
  };
}, []);

  // Add these new functions
  const handleAddPatientClick = (e, packageItem) => {
    e.stopPropagation(); // Prevent package selection

    // Ensure the package is selected so the patient is added to the right package
    if (packageItem) {
      setSelectedPackage(packageItem);
    }

    // Auto-select the services that belong to the clicked camp package
    const serviceMap = serviceApi.getServiceMap();
    // Match names case-insensitively against the real /api/services/ list so the
    // checkbox state (which compares by exact name) lines up correctly.
    const serviceNameLookup = new Map(
      (availableServices || []).map((service) => [
        String(service.name || '').trim().toLowerCase(),
        service.name
      ])
    );
    const packageServices = (packageItem?.service_ids || [])
      .map((serviceId) => serviceMap[serviceId] || serviceMap[String(serviceId)])
      .filter(Boolean)
      .map((name) => serviceNameLookup.get(String(name).trim().toLowerCase()) || name);

    setPatientForm((prev) => ({
      ...prev,
      services: packageServices
    }));

    setShowAddPatientModal(true);
  };

// for addd patient modal
const handlePhotoChange = (e) => {
  setPhotoFile(e.target.files[0]);
};

GlobalWorkerOptions.workerSrc = pdfjsWorker;

const convertBase64PdfToImage = async (base64) => {
  const pdfData = atob(base64);
  const uint8Array = new Uint8Array([...pdfData].map(char => char.charCodeAt(0)));
  const loadingTask = getDocument({ data: uint8Array });

  const pdf = await loadingTask.promise;
  const page = await pdf.getPage(1);

  const scale = 2;
  const viewport = page.getViewport({ scale });
  const canvas = document.createElement("canvas");
  canvas.width = viewport.width;
  canvas.height = viewport.height;

  const context = canvas.getContext("2d");
  await page.render({ canvasContext: context, viewport }).promise;

  return canvas.toDataURL("image/png");
};

const handleEditPatientClick = async (patient) => {
  try {
    setIsEditing(true);
    
    // Convert services array to comma-separated string for display
    const servicesString = Array.isArray(patient.services) 
      ? patient.services.join(', ')
      : patient.services || '';
    
    // Map patient data to edit form structure
    setEditForm({
      patient_name: patient.name || '',
      age: patient.age || '',
      gender: patient.gender || '',
      contact_number: patient.phone || patient.contact_number || '',
      loan_account_number: patient.loan_account_number || '',
      aadhar_number: patient.aadhar_number || '',
      services: patient.services || []
    });
    
    // Store the patient being edited
    setEditingPatient(patient);
    setShowEditPatientModal(true);
  } catch (error) {
    console.error('Error setting up edit form:', error);
    alert('Error loading patient data for editing');
  } finally {
    setIsEditing(false);
  }
};

const handleEditFormChange = (field, value) => {
  setEditForm(prev => ({
    ...prev,
    [field]: value
  }));
};

const handleSubmitEdit = async (e) => {
  e.preventDefault();
  e.stopPropagation(); // Add this
  
  if (!editingPatient) return;
  
  try {
    // Custom validation for required fields only
    const requiredFields = {
      patient_name: 'Patient Name',
      age: 'Age',
      gender: 'Gender',
      services: 'Services'
    };
    
    const errors = [];
    
    Object.keys(requiredFields).forEach(field => {
      if (!editForm[field] || editForm[field].toString().trim() === '') {
        errors.push(requiredFields[field]);
      }
    });
    
    if (errors.length > 0) {
      alert(`Please fill in: ${errors.join(', ')}`);
      return;
    }
    
    // Prepare data for API
    const updateData = {
      ...editForm,
      services: editForm.services
    };
    
    // If services is a string, convert to array
    if (typeof updateData.services === 'string') {
      updateData.services = updateData.services
        .split(',')
        .map(s => s.trim())
        .filter(s => s.length > 0);
    }
    
    // Handle optional fields - convert empty strings to null
    if (updateData.contact_number === '') {
      updateData.contact_number = null;
    }
    if (updateData.aadhar_number === '') {
      updateData.aadhar_number = null;
    }
    if (updateData.loan_account_number === '') {
      updateData.loan_account_number = null;
    }

    // Call edit API
    await onsiteAPI.editPatient(editingPatient.id, updateData);
    
    // Close modal and refresh data
    setShowEditPatientModal(false);
    setEditingPatient(null);
    
    // Refresh patient list
    if (selectedCamp && selectedPackage) {
      await fetchPackagePatients(selectedCamp.id, selectedPackage.id);
    }
    
    alert('Patient updated successfully!');
  } catch (error) {
    console.error('Error updating patient:', error);
    alert(`Error: ${error.response?.data?.message || 'Failed to update patient'}`);
  }
};


const isServiceSelected = (serviceName) =>
  (patientForm.services || []).some(
    (service) =>
      String(service).trim().toLowerCase() === String(serviceName).trim().toLowerCase()
  );

const handleServiceToggle = (serviceName) => {
  setPatientForm(prev => {
    const currentServices = prev.services || [];
    const normalizedName = String(serviceName).trim().toLowerCase();
    const isSelected = currentServices.some(
      (service) => String(service).trim().toLowerCase() === normalizedName
    );
    
    return {
      ...prev,
      services: isSelected 
        ? currentServices.filter(
            (service) => String(service).trim().toLowerCase() !== normalizedName
          )
        : [...currentServices, serviceName]
    };
  });
};

const generateQRCodeBase64 = async (patient) => {
  const patientInfo = `Patient ID: ${patient.unique_patient_id}
  Name: ${patient.name}
  Age: ${patient.age}
  Gender: ${patient.gender}`;

  try {
    console.log("Generating QR Code for:", patientInfo);
    
    // Check if QRCode library exists
    if (typeof QRCode === 'undefined') {
      throw new Error("QRCode library not loaded");
    }
    
    const qrCode = await QRCode.toDataURL(patientInfo, {
      width: 120,
      margin: 2,
      color: {
        dark: '#000000',
        light: '#FFFFFF'
      }
    });
    
    console.log("QR Code generated successfully");
    return qrCode;
  } catch (err) {
    console.error("QR generation error:", err);
    // Return a placeholder or throw the error instead of empty string
    throw err;
  }
};

const handleIdChange = (e) => {
  setIdFile(e.target.files[0]);
};


const handleLoanChange = (e) => {
  setLoanFile(e.target.files[0]);
};

  
  const handlePatientFormChange = (field, value) => {
    setPatientForm(prev => ({
      ...prev,
      [field]: value
    }));
  };
  
const handleSubmitPatient = async (e) => {
  e.preventDefault();
  
  // Validate form fields
  const validation = onsiteAPI.validatePatientData(patientForm);
  if (!validation.isValid) {
    alert(`Please fill in: ${validation.errors.join(', ')}`);
    return;
  }
  

  // Validate selections
  if (!selectedCamp) {
    alert('Please select a camp first');
    return;
  }

  if (!selectedPackage) {
    alert('Please select a package first - try clicking the package again');
    return;
  }

  setIsSubmittingPatient(true);
  
  try {
    const patientData = onsiteAPI.formatPatientData(patientForm, selectedCamp, selectedPackage);
    await onsiteAPI.addPatient(patientData);
    // Reset form
    setPatientForm({ patient_id: '', name: '', age: '', gender: '', phone: '', services: [], load_number: '' });
    setShowAddPatientModal(false);
    
    // Refresh patient list
    fetchPackagePatients(selectedCamp.id, selectedPackage.id);
    
    alert('Patient added successfully!');
  } catch (error) {
    console.error(patientForm);
    console.error('Error adding patient:', error);
    alert(`Error: ${error.response?.data?.message || 'Failed to add patient'}`);
  } finally {
    setIsSubmittingPatient(false);
  }
};
  const handleCloseModal = () => {
    setShowAddPatientModal(false);
    setPatientForm({ name: '', age: '', gender: '', phone: '', services: [], load_number: '' });
  };

  // NEW: Render QR/Photo Scan Modal
  const renderScanModal = () => {
    const isQRScan = showQRScanModal;
    const isPhotoScan = showPhotoScanModal;
    
    if (!isQRScan && !isPhotoScan) return null;

    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000
      }}>
        <div style={{
          backgroundColor: COLORS.white,
          borderRadius: '12px',
          padding: '24px',
          width: '90%',
          maxWidth: '600px',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
          position: 'relative'
        }}>
          {/* Modal Header */}
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            marginBottom: '20px',
            borderBottom: `1px solid ${COLORS.mediumGrey}`,
            paddingBottom: '12px'
          }}>
            <h2 style={{ 
              margin: 0, 
              fontSize: '20px', 
              fontWeight: '600',
              color: COLORS.darkText 
            }}>
              {isQRScan ? 'QR Code Scan' : 'Photo Scan'}
            </h2>
            <button
              onClick={handleCloseScanModal}
              style={{
                background: 'none',
                border: 'none',
                fontSize: '24px',
                cursor: 'pointer',
                color: COLORS.mediumText,
                padding: '4px'
              }}
            >
              ×
            </button>
          </div>

          {/* Camera View or Result */}
{!scanResult ? (
  <div>
    <div style={{
      position: 'relative',
      backgroundColor: '#000',
      borderRadius: '8px',
      overflow: 'hidden',
      marginBottom: '16px'
    }}>
      <video
        ref={videoRef}
        autoPlay
        playsInline
        style={{ width: '100%', maxHeight: '400px', display: 'block' }}
      />
        <canvas
                ref={canvasRef}
                style={{ display: 'none' }}
              />


      
{/* Camera Toggle Button — only show for QR Scan mode */}
{showQRScanModal && (
  <button
    onClick={() => {
      setUseFrontCamera(prev => !prev);
      stopQRScanner();
      setTimeout(() => startQRScanner(), 300);
    }}
    style={{
      position: 'absolute',
      top: '8px',
      right: '8px',
      backgroundColor: 'rgba(0,0,0,0.5)',
      color: 'white',
      border: 'none',
      borderRadius: '6px',
      padding: '6px 10px',
      cursor: 'pointer',
      fontSize: '12px',
      fontWeight: '500',
      zIndex: 10
    }}
  >
    {useFrontCamera ? '🔄 Back' : '🔄 Front'}
  </button>
)}        

      {/* Google Pay style scanning border overlay — only for QR mode */}
      {showQRScanModal && (
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '200px',
          height: '200px',
          border: '3px solid rgba(255,255,255,0.8)',
          borderRadius: '16px',
          pointerEvents: 'none'
        }}>
          {/* Corner highlights */}
          {['top-left','top-right','bottom-left','bottom-right'].map(pos => (
            <div key={pos} style={{
              position: 'absolute',
              width: '30px',
              height: '30px',
              borderColor: '#3b82f6',
              borderStyle: 'solid',
              borderRadius: '4px',
              ...(pos.includes('top') ? { top: '-3px' } : { bottom: '-3px' }),
              ...(pos.includes('left') ? { left: '-3px' } : { right: '-3px' }),
              borderTopWidth: pos.includes('top') ? '4px' : '0',
              borderBottomWidth: pos.includes('bottom') ? '4px' : '0',
              borderLeftWidth: pos.includes('left') ? '4px' : '0',
              borderRightWidth: pos.includes('right') ? '4px' : '0',
            }} />
          ))}
        </div>
      )}
    </div>

    {/* Show scanning text instead of Capture button for QR mode */}
    {showQRScanModal ? (
      <p style={{ textAlign: 'center', color: '#6b7280', fontSize: '14px', marginTop: '12px' }}>
        {isScanning ? '🔍 Scanning... Place QR code in the box' : 'Detected!'}
      </p>
    ) : (
      /* Keep the original Capture button only for Photo Scan mode */
      <div style={{ textAlign: 'center' }}>
       <button onClick={handleCapture} disabled={isScanning || !isCameraReady} style={{
          padding: '12px 32px',
          backgroundColor: isScanning ? COLORS.mediumGrey : (isCameraReady ? COLORS.success : COLORS.mediumGrey),
          color: COLORS.white,
          border: 'none',
          borderRadius: '8px',
          fontSize: '16px',
          fontWeight: '500',
          cursor: (isScanning || !isCameraReady) ? 'not-allowed' : 'pointer'
        }}>
          {isScanning ? 'Scanning...' : (!isCameraReady ? 'Preparing...' : 'Capture')}
        </button>
      </div>
     )}
  </div>
) : (
  <div>
    {/* Scan Result Display */}
    <div style={{
      backgroundColor: COLORS.lightGrey,
      padding: '20px',
      borderRadius: '8px',
      marginBottom: '20px',
      border: `1px solid ${COLORS.mediumGrey}`
    }}>
      <h3 style={{ margin: '0 0 16px 0', fontSize: '16px', fontWeight: '600', color: COLORS.darkText }}>
        Patient Details
      </h3>
      <div style={{ display: 'grid', gap: '12px' }}>
        <div>
          <p style={{ margin: 0, fontSize: '12px', color: COLORS.mediumText, marginBottom: '4px' }}>Patient ID</p>
          <p style={{ margin: 0, fontSize: '16px', fontWeight: '500', color: COLORS.darkText }}>
            {scanResult.patient?.unique_patient_id || scanResult.patient_id || 'N/A'}
          </p>
        </div>
        <div>
          <p style={{ margin: 0, fontSize: '12px', color: COLORS.mediumText, marginBottom: '4px' }}>Name</p>
          <p style={{ margin: 0, fontSize: '16px', fontWeight: '500', color: COLORS.darkText }}>
            {scanResult.patient?.patient_name || scanResult.patient?.name || 'N/A'}
            {scanResult.patient?.name || 'N/A'}
          </p>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
          <div>
            <p style={{ margin: 0, fontSize: '12px', color: COLORS.mediumText, marginBottom: '4px' }}>Age</p>
            <p style={{ margin: 0, fontSize: '16px', fontWeight: '500', color: COLORS.darkText }}>
              {scanResult.patient?.age || 'N/A'}
            </p>
          </div>
          <div>
            <p style={{ margin: 0, fontSize: '12px', color: COLORS.mediumText, marginBottom: '4px' }}>Gender</p>
            <p style={{ margin: 0, fontSize: '16px', fontWeight: '500', color: COLORS.darkText }}>
              {scanResult.patient?.gender || 'N/A'}
            </p>
          </div>
        </div>
          <div style={{
             marginTop: '8px',
             backgroundColor: '#fef3c7',
             border: '1px solid #f59e0b',
             borderRadius: '8px',
             padding: '12px 16px',
             textAlign: 'center'
           }}>
             <p style={{ margin: 0, fontSize: '13px', color: '#92400e', fontWeight: '500' }}>Reporting Location</p>
             <p style={{ margin: '4px 0 0 0', fontSize: '20px', fontWeight: '700', color: '#b45309' }}>
               🪧 Please Go to Counter No. 2 for Reporting
             </p>
           </div>
      </div>
    </div>

    {/* Action Buttons */}
    <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
      <button
        onClick={handleCloseScanModal}
        disabled={isVerifying}
        style={{
          padding: '10px 20px',
          border: `1px solid ${COLORS.mediumGrey}`,
          borderRadius: '8px',
          backgroundColor: COLORS.white,
          color: COLORS.mediumText,
          cursor: isVerifying ? 'not-allowed' : 'pointer',
          fontSize: '14px',
          fontWeight: '500'
        }}
      >
        Cancel
      </button>
      <button
        onClick={handleVerifyAndPrint}
        disabled={isVerifying}
        style={{
          padding: '10px 20px',
          border: 'none',
          borderRadius: '8px',
          backgroundColor: isVerifying ? COLORS.mediumGrey : COLORS.success,
          color: COLORS.white,
          cursor: isVerifying ? 'not-allowed' : 'pointer',
          fontSize: '14px',
          fontWeight: '500',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}
      >
        {isVerifying ? (
          <>
            <div style={{
              width: '16px',
              height: '16px',
              border: '2px solid transparent',
              borderTop: '2px solid white',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite'
            }}></div>
            Processing...
          </>
        ) : (
          'Verify & Print'
        )}
      </button>
    </div>
  </div>
)}
        </div>
      </div>
    );
  };


  

  // ADD PATIENT MODAL FUNCTION - ADDED HERE
  const renderAddPatientModal = () => {
    if (!showAddPatientModal) return null;

    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000
      }}>
        <div style={{
          backgroundColor: COLORS.white,
          borderRadius: '12px',
          padding: '32px',
          width: '90%',
          maxWidth: '500px',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
          position: 'relative',
          maxHeight: '90vh',
          overflowY: 'auto'
        }}>
          {/* Modal Header */}
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            marginBottom: '24px',
            borderBottom: `1px solid ${COLORS.mediumGrey}`,
            paddingBottom: '16px'
          }}>
            <h2 style={{ 
              margin: 0, 
              fontSize: '20px', 
              fontWeight: '600',
              color: COLORS.darkText 
            }}>
              Add New Patient
            </h2>
            <button
              onClick={handleCloseModal}
              style={{
                background: 'none',
                border: 'none',
                fontSize: '24px',
                cursor: 'pointer',
                color: COLORS.mediumText,
                padding: '4px',
                borderRadius: '4px',
                transition: 'all 0.2s'
              }}
            >
              ×
            </button>
          </div>

          {/* Selected Package Info */}
          {selectedPackage && (
            <div style={{
              backgroundColor: COLORS.lightGrey,
              padding: '12px 16px',
              borderRadius: '8px',
              marginBottom: '24px',
              border: `1px solid ${COLORS.mediumGrey}`
            }}>
              <p style={{ margin: 0, fontSize: '14px', color: COLORS.mediumText }}>
                <strong>Adding patient to:</strong> {selectedPackage.name}
              </p>
              <p style={{ margin: '4px 0 0 0', fontSize: '12px', color: COLORS.lightText }}>
                Camp: {selectedCamp?.location}
              </p>
            </div>
          )}

          {/* Form */}
          <form onSubmit={handleSubmitPatient}>
            <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              fontSize: '14px',
              fontWeight: '500',
              color: COLORS.darkText,
              marginBottom: '8px'
            }}>
              Patient ID *
            </label>
            <input
              type="text"
              value={patientForm.patient_id}
              onChange={(e) => handlePatientFormChange('patient_id', e.target.value)}
              placeholder="Enter patient ID"
              required
              style={{
                width: '100%',
                padding: '12px 16px',
                border: `1px solid ${COLORS.mediumGrey}`,
                borderRadius: '8px',
                fontSize: '14px',
                outline: 'none',
                transition: 'all 0.2s',
                boxSizing: 'border-box'
              }}
            />
          </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: COLORS.darkText,
                marginBottom: '8px'
              }}>
                Patient Name *
              </label>
              <input
                type="text"
                value={patientForm.name}
                onChange={(e) => handlePatientFormChange('name', e.target.value)}
                placeholder="Enter patient's full name"
                required
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: `1px solid ${COLORS.mediumGrey}`,
                  borderRadius: '8px',
                  fontSize: '14px',
                  outline: 'none',
                  transition: 'all 0.2s',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            <div style={{ display: 'flex', gap: '16px', marginBottom: '20px' }}>
              <div style={{ flex: 1 }}>
                <label style={{
                  display: 'block',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: COLORS.darkText,
                  marginBottom: '8px'
                }}>
                  Age *
                </label>
                <input
                  type="number"
                  value={patientForm.age}
                  onChange={(e) => handlePatientFormChange('age', e.target.value)}
                  placeholder="Enter age"
                  required
                  min="1"
                  max="120"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: `1px solid ${COLORS.mediumGrey}`,
                    borderRadius: '8px',
                    fontSize: '14px',
                    outline: 'none',
                    transition: 'all 0.2s',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              <div style={{ flex: 1 }}>
                <label style={{
                  display: 'block',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: COLORS.darkText,
                  marginBottom: '8px'
                }}>
                  Gender *
                </label>
                <select
                  value={patientForm.gender}
                  onChange={(e) => handlePatientFormChange('gender', e.target.value)}
                  required
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: `1px solid ${COLORS.mediumGrey}`,
                    borderRadius: '8px',
                    fontSize: '14px',
                    outline: 'none',
                    transition: 'all 0.2s',
                    boxSizing: 'border-box',
                    backgroundColor: COLORS.white,
                    cursor: 'pointer'
                  }}
                >
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
              </div>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: COLORS.darkText,
                marginBottom: '8px'
              }}>
                Phone Number *
              </label>
              <input
                type="tel"
                value={patientForm.phone}
                onChange={(e) => handlePatientFormChange('phone', e.target.value)}
                placeholder="Enter phone number (e.g., +91 9876543210)"
                pattern="[+]?[0-9\s\-]{10,15}"
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: `1px solid ${COLORS.mediumGrey}`,
                  borderRadius: '8px',
                  fontSize: '14px',
                  outline: 'none',
                  transition: 'all 0.2s',
                  boxSizing: 'border-box'
                }}
              />
              <p style={{
                fontSize: '12px',
                color: COLORS.lightText,
                marginTop: '4px',
                margin: '4px 0 0 0'
              }}>
                Include country code if applicable
              </p>
            </div>

            <div style={{ marginBottom: '20px' }}>      
  <label style={{      
    display: 'block',      
    fontSize: '14px',      
    fontWeight: '500',      
    color: COLORS.darkText,      
    marginBottom: '8px'      
  }}>      
    Other Number      
  </label>      
  <input      
    type="text"      
    value={patientForm.load_number}      
    onChange={(e) => handlePatientFormChange('load_number', e.target.value)}      
    placeholder="Enter loan number"      
    style={{      
      width: '100%',      
      padding: '12px 16px',      
      border: `1px solid ${COLORS.mediumGrey}`,      
      borderRadius: '8px',      
      fontSize: '14px',      
      outline: 'none',      
      transition: 'all 0.2s',      
      boxSizing: 'border-box'      
    }}      
  />      
</div>                                                                                                    
<div style={{ marginBottom: '24px' }}>
  <label style={{
    display: 'block',
    fontSize: '14px',
    fontWeight: '500',
    color: COLORS.darkText,
    marginBottom: '8px'
  }}>
    Services *
  </label>
  
  {loadingServices ? (
    <div style={{ padding: '12px', textAlign: 'center', color: COLORS.mediumText }}>
      Loading services...
    </div>
  ) : (
    <div style={{
      border: `1px solid ${COLORS.mediumGrey}`,
      borderRadius: '8px',
      padding: '12px',
      maxHeight: '200px',
      overflowY: 'auto',
      backgroundColor: COLORS.white
    }}>
      {availableServices.length === 0 ? (
        <p style={{ color: COLORS.mediumText, margin: 0, padding: '8px' }}>
          No services available
        </p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {availableServices.map(service => (
            <label 
              key={service.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '8px',
                cursor: 'pointer',
                borderRadius: '4px',
                transition: 'background-color 0.2s',
                backgroundColor: isServiceSelected(service.name) 
                  ? COLORS.lightGrey 
                  : 'transparent'
              }}
            >
              <input
                type="checkbox"
                checked={isServiceSelected(service.name)}
                onChange={() => handleServiceToggle(service.name)}
                style={{
                  marginRight: '8px',
                  width: '16px',
                  height: '16px',
                  cursor: 'pointer'
                }}
              />
              <span style={{ 
                fontSize: '14px', 
                color: COLORS.darkText,
                fontWeight: isServiceSelected(service.name) ? '500' : '400'
              }}>
                {service.name}
              </span>
            </label>
          ))}
        </div>
      )}
    </div>
  )}
  
  {patientForm.services.length > 0 && (
    <p style={{
      fontSize: '12px',
      color: COLORS.mediumText,
      marginTop: '8px',
      margin: '8px 0 0 0'
    }}>
      Selected: {patientForm.services.join(', ')}
    </p>
  )}
</div>

            {/* Form Actions */}
            <div style={{ 
              display: 'flex', 
              gap: '12px', 
              justifyContent: 'flex-end',
              borderTop: `1px solid ${COLORS.mediumGrey}`,
              paddingTop: '20px'
            }}>
              <button
                type="button"
                onClick={handleCloseModal}
                disabled={isSubmittingPatient}
                style={{
                  padding: '10px 20px',
                  border: `1px solid ${COLORS.mediumGrey}`,
                  borderRadius: '8px',
                  backgroundColor: COLORS.white,
                  color: COLORS.mediumText,
                  cursor: isSubmittingPatient ? 'not-allowed' : 'pointer',
                  fontSize: '14px',
                  fontWeight: '500',
                  transition: 'all 0.2s'
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmittingPatient}
                style={{
                  padding: '10px 20px',
                  border: 'none',
                  borderRadius: '8px',
                  backgroundColor: isSubmittingPatient ? COLORS.mediumGrey : COLORS.success,
                  color: COLORS.white,
                  cursor: isSubmittingPatient ? 'not-allowed' : 'pointer',
                  fontSize: '14px',
                  fontWeight: '500',
                  transition: 'all 0.2s',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                {isSubmittingPatient ? (
                  <>
                    <div style={{
                      width: '16px',
                      height: '16px',
                      border: '2px solid transparent',
                      borderTop: '2px solid white',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite'
                    }}></div>
                    Adding...
                  </>
                ) : (
                  'Add Patient'
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  };
  
const renderEditPatientModal = () => {
  if (!showEditPatientModal || !editingPatient) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: COLORS.white,
        borderRadius: '12px',
        padding: '32px',
        width: '90%',
        maxWidth: '500px',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
        position: 'relative',
        maxHeight: '90vh',
        overflowY: 'auto'
      }}>
        {/* Modal Header */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          marginBottom: '24px',
          borderBottom: `1px solid ${COLORS.mediumGrey}`,
          paddingBottom: '16px'
        }}>
          <h2 style={{ 
            margin: 0, 
            fontSize: '20px', 
            fontWeight: '600',
            color: COLORS.darkText 
          }}>
            Edit Patient
          </h2>
          <button
            onClick={() => {
              setShowEditPatientModal(false);
              setEditingPatient(null);
            }}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: COLORS.mediumText,
              padding: '4px',
              borderRadius: '4px',
              transition: 'all 0.2s'
            }}
          >
            ×
          </button>
        </div>

        {/* Patient ID Info */}
        <div style={{
          backgroundColor: COLORS.lightGrey,
          padding: '12px 16px',
          borderRadius: '8px',
          marginBottom: '24px',
          border: `1px solid ${COLORS.mediumGrey}`
        }}>
          <p style={{ margin: 0, fontSize: '14px', color: COLORS.mediumText }}>
            <strong>Editing:</strong> {editingPatient.name} (ID: {editingPatient.unique_patient_id})
          </p>
        </div>

        {/* Edit Form - Using div instead of form to avoid browser validation */}
        <div>
          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              fontSize: '14px',
              fontWeight: '500',
              color: COLORS.darkText,
              marginBottom: '8px'
            }}>
              Patient Name *
            </label>
            <input
              type="text"
              value={editForm.patient_name}
              onChange={(e) => handleEditFormChange('patient_name', e.target.value)}
              placeholder="Enter patient's full name"
              style={{
                width: '100%',
                padding: '12px 16px',
                border: `1px solid ${COLORS.mediumGrey}`,
                borderRadius: '8px',
                fontSize: '14px',
                outline: 'none',
                transition: 'all 0.2s',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ display: 'flex', gap: '16px', marginBottom: '20px' }}>
            <div style={{ flex: 1 }}>
              <label style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: COLORS.darkText,
                marginBottom: '8px'
              }}>
                Age *
              </label>
              <input
                type="number"
                value={editForm.age}
                onChange={(e) => handleEditFormChange('age', e.target.value)}
                placeholder="Enter age"
                min="1"
                max="120"
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: `1px solid ${COLORS.mediumGrey}`,
                  borderRadius: '8px',
                  fontSize: '14px',
                  outline: 'none',
                  transition: 'all 0.2s',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            <div style={{ flex: 1 }}>
              <label style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: COLORS.darkText,
                marginBottom: '8px'
              }}>
                Gender *
              </label>
              <select
                value={editForm.gender}
                onChange={(e) => handleEditFormChange('gender', e.target.value)}
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: `1px solid ${COLORS.mediumGrey}`,
                  borderRadius: '8px',
                  fontSize: '14px',
                  outline: 'none',
                  transition: 'all 0.2s',
                  boxSizing: 'border-box',
                  backgroundColor: COLORS.white,
                  cursor: 'pointer'
                }}
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              fontSize: '14px',
              fontWeight: '500',
              color: COLORS.darkText,
              marginBottom: '8px'
            }}>
              Phone Number (Optional)
            </label>
            <input
              type="text"
              value={editForm.contact_number}
              onChange={(e) => handleEditFormChange('contact_number', e.target.value)}
              placeholder="Enter phone number"
              style={{
                width: '100%',
                padding: '12px 16px',
                border: `1px solid ${COLORS.mediumGrey}`,
                borderRadius: '8px',
                fontSize: '14px',
                outline: 'none',
                transition: 'all 0.2s',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              fontSize: '14px',
              fontWeight: '500',
              color: COLORS.darkText,
              marginBottom: '8px'
            }}>
              Aadhar Number (Optional)
            </label>
            <input
              type="text"
              value={editForm.aadhar_number}
              onChange={(e) => handleEditFormChange('aadhar_number', e.target.value)}
              placeholder="Enter Aadhar number"
              style={{
                width: '100%',
                padding: '12px 16px',
                border: `1px solid ${COLORS.mediumGrey}`,
                borderRadius: '8px',
                fontSize: '14px',
                outline: 'none',
                transition: 'all 0.2s',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              fontSize: '14px',
              fontWeight: '500',
              color: COLORS.darkText,
              marginBottom: '8px'
            }}>
              Loan Account Number (Optional)
            </label>
            <input
              type="text"
              value={editForm.loan_account_number}
              onChange={(e) => handleEditFormChange('loan_account_number', e.target.value)}
              placeholder="Enter loan account number"
              style={{
                width: '100%',
                padding: '12px 16px',
                border: `1px solid ${COLORS.mediumGrey}`,
                borderRadius: '8px',
                fontSize: '14px',
                outline: 'none',
                transition: 'all 0.2s',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={{
              display: 'block',
              fontSize: '14px',
              fontWeight: '500',
              color: COLORS.darkText,
              marginBottom: '8px'
            }}>
              Services *
            </label>
            <textarea
              value={Array.isArray(editForm.services) ? editForm.services.join(', ') : editForm.services}
              onChange={(e) => handleEditFormChange('services', e.target.value)}
              placeholder="Enter services (comma-separated, e.g., Consultation, Blood Test, X-Ray)"
              rows={3}
              style={{
                width: '100%',
                padding: '12px 16px',
                border: `1px solid ${COLORS.mediumGrey}`,
                borderRadius: '8px',
                fontSize: '14px',
                outline: 'none',
                transition: 'all 0.2s',
                boxSizing: 'border-box',
                resize: 'vertical',
                fontFamily: 'inherit'
              }}
            />
            <p style={{
              fontSize: '12px',
              color: COLORS.lightText,
              marginTop: '4px',
              margin: '4px 0 0 0'
            }}>
              Separate multiple services with commas
            </p>
          </div>

          {/* Form Actions */}
          <div style={{ 
            display: 'flex', 
            gap: '12px', 
            justifyContent: 'flex-end',
            borderTop: `1px solid ${COLORS.mediumGrey}`,
            paddingTop: '20px'
          }}>
            <button
              type="button"
              onClick={() => {
                setShowEditPatientModal(false);
                setEditingPatient(null);
              }}
              disabled={isEditing}
              style={{
                padding: '10px 20px',
                border: `1px solid ${COLORS.mediumGrey}`,
                borderRadius: '8px',
                backgroundColor: COLORS.white,
                color: COLORS.mediumText,
                cursor: isEditing ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'all 0.2s'
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleSubmitEdit}
              disabled={isEditing}
              style={{
                padding: '10px 20px',
                border: 'none',
                borderRadius: '8px',
                backgroundColor: isEditing ? COLORS.mediumGrey : '#3b82f6',
                color: COLORS.white,
                cursor: isEditing ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'all 0.2s',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              {isEditing ? (
                <>
                  <div style={{
                    width: '16px',
                    height: '16px',
                    border: '2px solid transparent',
                    borderTop: '2px solid white',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                  }}></div>
                  Updating...
                </>
              ) : (
                'Update Patient'
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};


 const fetchData = useCallback(async () => {
    try {
      const camps = await onsiteAPI.getAllCamps();
      setData(camps);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching camps data:', error);
      setLoading(false);
    }
  }, []);



  useEffect(() => {
    fetchData();
    fetchAvailableServices();
  }, [fetchData]);


  const fetchPackages = async (campId) => {
    setLoadingPackages(true);
    try {
      const campDetails = await onsiteAPI.getCampDetails(campId);
      setPackages(campDetails.packages || []);
    } catch (error) {
      console.error('Error fetching packages:', error);
      setPackages([]);
    } finally {
      setLoadingPackages(false);
    }
};



  const fetchPackagePatients = async (campId, packageId) => {
    setLoadingPatients(true);
    try {
      const patients = await onsiteAPI.getPackagePatients(campId, packageId);
      setPatients(patients);
      setOriginalPatients(patients);
    } catch (error) {
      console.error('Error fetching package patients:', error);
      setPatients([]);
      setOriginalPatients([]);
    } finally {
      setLoadingPatients(false);
    }
  };


  const handleAddDetailClick = (patient) => {
  setSelectedDetailPatient(patient);
  console.log("Selected patient for detail view:", patient);
  console.log("Photo file:", selectedDetailPatient);
  setShowDetailModal(true);
  setPhotoFile(null);
  setIdFile(null);
};



const handleCloseDetailModal = () => {
  setShowDetailModal(false);
  setPhotoFile(null);
  setIdFile(null);
};








  const handleCampClick = (camp) => {
    setSelectedCamp(camp);
    setSelectedPackage(null);
    setPatients([]);
    setOriginalPatients([]);
    setSearchTerm('');
    fetchPackages(camp.id);
  };


  const handlePackageClick = (packageItem) => {
    setSelectedPackage(packageItem);
    setSearchTerm('');
    fetchPackagePatients(selectedCamp.id, packageItem.id);
  };


  const handleSearch = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    console.log('Searching for:', term);
    const filtered = onsiteUtils.filterPatients(originalPatients, term);
    console.log('Filtered patients:', filtered);
    setPatients(filtered);
  };





const handlePrintQR = async (patient) => {
  try {
    // Make API call to mark patient as checked-in & trigger thermal print
    const result = await onsiteAPI.printThermalSlips([patient.id]);
    
    // Open print window with patient QR
    const printWindow = window.open('', '_blank');
    const printContent = onsiteAPI.generatePrintContent(patient);
    printWindow.document.write(printContent);

  } catch (error) {
    console.error('Failed to print QR:', error);
    alert('Error printing QR. Check console.');
  }
};



  const handleCampStatus = (patientId) => {
    // Add camp status logic here
    console.log('Camp status for patient:', patientId);
  };


  const formatDate = onsiteUtils.formatDate;
  const getCampStatus = onsiteUtils.getCampStatus;


  // Add the missing render functions
  const renderCampPackages = () => {
    if (!selectedCamp) return null;

    return (
      <div style={{ marginTop: '16px', borderTop: '1px solid #e5e7eb', paddingTop: '16px' }}>
        <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px' }}>
          Packages for Camp: {selectedCamp.location} (ID: {selectedCamp.id})
        </h3>
        {loadingPackages ? (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <div style={spinnerStyle}></div>
            <p style={{ marginTop: '12px', color: '#6b7280' }}>Loading packages...</p>
          </div>
        ) : packages.length === 0 ? (
          <p style={{ color: '#6b7280' }}>No packages found for this camp.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {packages.map(packageItem => (
              <div key={packageItem.id} style={{
                border: '1px solid #e5e7eb',
                borderRadius: '8px',
                padding: '16px',
                backgroundColor: selectedPackage?.id === packageItem.id ? '#eff6ff' : 'white',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
              onClick={() => handlePackageClick(packageItem)}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
                <div>
                    <h4 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>
                    {packageItem.name}
                    </h4>
                    <p style={{ margin: '4px 0 0 0', color: '#6b7280', fontSize: '14px' }}>
                    {formatDate(packageItem.start_date)} - {formatDate(packageItem.end_date)}
                    </p>
                </div>

                {/* NEW: Action Buttons - QR Scan, Photo Scan, Add Patient */}
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleQRScanClick();
                    }}
                    style={{
                      backgroundColor: COLORS.orange,
                      color: COLORS.white,
                      border: 'none',
                      borderRadius: '6px',
                      padding: '8px 16px',
                      cursor: 'pointer',
                      fontWeight: '500',
                      fontSize: '14px',
                      transition: 'all 0.2s',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px'
                    }}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <rect x="3" y="3" width="7" height="7" strokeWidth="2"/>
                      <rect x="14" y="3" width="7" height="7" strokeWidth="2"/>
                      <rect x="3" y="14" width="7" height="7" strokeWidth="2"/>
                      <path d="M14 14h7v7h-7z" strokeWidth="2"/>
                    </svg>
                    QR SCAN
                  </button>

                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handlePhotoScanClick();
                    }}
                    style={{
                      backgroundColor: COLORS.aquaBlue,
                      color: COLORS.white,
                      border: 'none',
                      borderRadius: '6px',
                      padding: '8px 16px',
                      cursor: 'pointer',
                      fontWeight: '500',
                      fontSize: '14px',
                      transition: 'all 0.2s',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px'
                    }}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                      <circle cx="12" cy="13" r="3" strokeWidth="2"/>
                    </svg>
                    PHOTO SCAN
                  </button>

                  <button
                    onClick={(e) => handleAddPatientClick(e, packageItem)}
                    style={{
                      backgroundColor: COLORS.success,
                      color: COLORS.white,
                      border: 'none',
                      borderRadius: '6px',
                      padding: '8px 16px',
                      cursor: 'pointer',
                      fontWeight: '500',
                      fontSize: '14px',
                      transition: 'all 0.2s',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px'
                    }}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                    </svg>
                    ADD PATIENT
                  </button>
                </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const renderCampPatients = () => {
    if (!selectedPackage) return null;

    return (
      <div style={{ marginTop: '16px', borderTop: `1px solid ${COLORS.mediumGrey}`, paddingTop: '16px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h3 style={{ fontSize: '18px', fontWeight: '600', margin: 0, color: COLORS.darkText }}>
            Patients for Package: {selectedPackage.name}
          </h3>

          <div style={{ display: 'flex', gap: '8px', width: '300px' }}>
            <div style={{ position: 'relative', flex: 1 }}>
              <input
                type="text"
                placeholder="Search patients..."
                value={searchTerm}
                onChange={handleSearch}
                style={{
                  width: '100%',
                  padding: '8px 12px 8px 32px',
                  border: `1px solid ${COLORS.mediumGrey}`,
                  borderRadius: '6px',
                  fontSize: '14px',
                  outline: 'none',
                  transition: 'all 0.2s',
                  boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
                }}
              />
              <div style={{
                position: 'absolute',
                left: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                color: COLORS.lightText
              }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
            </div>
            {searchTerm && (
              <button
                onClick={() => {
                  setSearchTerm('');
                  setPatients(originalPatients);
                }}
                style={{
                  padding: '8px 12px',
                  backgroundColor: COLORS.lightGrey,
                  color: COLORS.mediumText,
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontWeight: '500',
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px'
                }}
              >
                Clear
              </button>
            )}
          </div>
        </div>


        {loadingPatients ? (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <div style={spinnerStyle}></div>
            <p style={{ marginTop: '12px', color: COLORS.mediumText }}>Loading patients...</p>
          </div>
        ) : patients.length === 0 ? (
          <div style={{
            backgroundColor: COLORS.lightGrey,
            padding: '24px',
            borderRadius: '8px',
            textAlign: 'center',
            border: `1px dashed ${COLORS.mediumGrey}`
          }}>
            <p style={{ color: COLORS.mediumText, marginBottom: '8px' }}>
              {searchTerm ? 'No matching patients found' : 'No patients found for this package'}
            </p>
            {searchTerm && (
              <button
                onClick={() => {
                  setSearchTerm('');
                  setPatients(originalPatients);
                }}
                style={{
                  backgroundColor: COLORS.lightGrey,
                  color: COLORS.darkText,
                  border: 'none',
                  borderRadius: '6px',
                  padding: '6px 12px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Clear search
              </button>
            )}
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {patients.map(patient => (
              <div key={patient.id} style={{
                border: `1px solid ${COLORS.mediumGrey}`,
                borderRadius: '8px',
                padding: '16px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                backgroundColor: COLORS.white,
                transition: 'all 0.2s'
              }}>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
                    <p style={{ margin: 0, fontWeight: '600', fontSize: '16px', color: COLORS.darkText }}>
                      {patient.name}
                    </p>
                    <span style={{
                      backgroundColor: COLORS.mediumGrey,
                      color: COLORS.darkGrey,
                      padding: '2px 8px',
                      borderRadius: '4px',
                      fontSize: '12px',
                      fontWeight: '500'
                    }}>
                      ID: {patient.patient_excel_id}
                    </span>
                  </div>
                  <div style={{ marginTop: '8px', display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                    <span style={{ fontSize: '14px', color: COLORS.mediumText }}>
                      Age: {patient.age}
                    </span>
                    <span style={{ fontSize: '14px', color: COLORS.mediumText }}>
                      Gender: {patient.gender}
                    </span>
                    <span style={{ fontSize: '14px', color: COLORS.mediumText }}>
                      Phone: {patient.phone}
                    </span>
                  </div>
                  <div style={{ marginTop: '4px' }}>
                    <span style={{ fontSize: '14px', color: COLORS.mediumText }}>
                      Services: {patient.services.join(', ')}
                    </span>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '8px', marginLeft: '16px' }}>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleAddDetailClick(patient);
                    }}
                    style={{
                      backgroundColor: COLORS.mediumGrey,
                      color: COLORS.darkText,
                      border: 'none',
                      borderRadius: '6px',
                      padding: '8px 16px',
                      cursor: 'pointer',
                      fontWeight: '500',
                      fontSize: '14px',
                      transition: 'all 0.2s'
                    }}
                  >
                    Add detail
                  </button>

                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handlePrintQR(patient);
                  }}
                  style={{
                    backgroundColor: COLORS.aquaBlue,
                    color: COLORS.white,
                    border: 'none',
                    borderRadius: '6px',
                    padding: '8px 16px',
                    cursor: 'pointer',
                    fontWeight: '500',
                    fontSize: '14px',
                    transition: 'all 0.2s'
                  }}
                >
                  Print QR
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEditPatientClick(patient);
                  }}
                  style={{
                    backgroundColor: '#3b82f6',
                    color: COLORS.white,
                    border: 'none',
                    borderRadius: '6px',
                    padding: '8px 16px',
                    cursor: 'pointer',
                    fontWeight: '500',
                    fontSize: '14px',
                    transition: 'all 0.2s'
                  }}
                >
                  Edit
                </button>

              </div>
            </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const renderCampProgressContent = () => {
    const readyCamps = data
      .filter(camp => camp.ready_to_go === true)
      .sort((a, b) => {
        const dateA = new Date(a.start_date).getTime() || 0;
        const dateB = new Date(b.start_date).getTime() || 0;
        if (dateB !== dateA) return dateB - dateA;
        return (b.id || 0) - (a.id || 0);
      });


    return (
      <div>
        <h2 style={{ marginBottom: '16px', fontSize: '20px', fontWeight: '600' }}>Camps Ready to Go</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {readyCamps.length === 0 && (
            <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>
              <p>No camps are marked ready to go.</p>
            </div>
          )}
          {readyCamps.map(camp => (
            <div key={camp.id}>
              <div
                onClick={() => handleCampClick(camp)}
                style={{
                  padding: '16px',
                  border: '1px solid #e5e7eb',
                  borderRadius: selectedCamp?.id === camp.id ? '8px 8px 0 0' : '8px',
                  cursor: 'pointer',
                  backgroundColor: selectedCamp?.id === camp.id ? '#eff6ff' : 'white',
                  transition: 'all 0.2s',
                  boxShadow: selectedCamp?.id === camp.id ? '0 2px 4px rgba(0, 0, 0, 0.1)' : 'none'
                }}
              >
                <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '600', color: '#1f2937' }}>
                  {camp.location} (ID: {camp.id})
                </h3>
                <p style={{ margin: '4px 0 0 0', color: '#6b7280', fontSize: '14px' }}>
                  {camp.district}, {camp.state} | {formatDate(camp.start_date)} - {formatDate(camp.end_date)}
                </p>
              </div>

              {selectedCamp?.id === camp.id && (
                <div style={{
                  border: '1px solid #e5e7eb',
                  borderTop: 'none',
                  borderRadius: '0 0 8px 8px',
                  padding: '0 16px 16px 16px',
                  backgroundColor: '#f8fafc'
                }}>
                  {renderCampPackages()}
                  {renderCampPatients()}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  };


  const renderDetailModal = () => {
    console.log('Modal state:', { showDetailModal, selectedDetailPatient }); // Debug log

    if (!showDetailModal || !selectedDetailPatient) {
      return null;
    }

    return (

      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1100
      }}>
        <div style={{
          backgroundColor: COLORS.white,
          borderRadius: '12px',
          padding: '24px',
          maxWidth: '400px',
          width: '100%',
          boxShadow: '0 10px 20px rgba(0,0,0,0.2)'
        }}>
          <h2 style={{ fontSize: '20px', marginBottom: '16px' }}>Upload Patient Details</h2>
          <div style={{ marginBottom: '16px', padding: '12px', backgroundColor: '#f3f4f6', borderRadius: '8px' }}>
            <p style={{ margin: '0', color: COLORS.darkText }}>
              <strong>Patient ID:</strong> {selectedDetailPatient.unique_patient_id}
            </p>
            <p style={{ margin: '4px 0 0', color: COLORS.darkText }}>
              <strong>Name:</strong> {selectedDetailPatient.name}
            </p>
          </div>

          <form onSubmit={handleDetailSubmit}>
            <div style={{ marginBottom: '16px' }}>
              <label style={{ 
                display: 'block',
                fontWeight: '500', 
                color: COLORS.darkText,
                marginBottom: '8px'
              }}>
                Patient Photo *
              </label>
              <input
                type="file"
                accept="image/*"
                capture="environment"
                onChange={handlePhotoChange}
                // required
                style={{ 
                  width: '100%',
                  padding: '8px',
                  border: `1px solid ${COLORS.mediumGrey}`,
                  borderRadius: '6px'
                }}
              />
            </div>

            <div style={{ marginBottom: '24px' }}>
              <label style={{ 
                display: 'block',
                fontWeight: '500', 
                color: COLORS.darkText,
                marginBottom: '8px'
              }}>
                Aadhar ID Document *
              </label>
              <input
                type="file"
                accept="image/*"
                capture="environment"
                onChange={handleIdChange}
                // required
                style={{ 
                  width: '100%',
                  padding: '8px',
                  border: `1px solid ${COLORS.mediumGrey}`,
                  borderRadius: '6px'
                }}
              />
            </div>
            <div style={{ marginBottom: '24px' }}>
              <label style={{ 
                display: 'block',
                fontWeight: '500', 
                color: COLORS.darkText,
                marginBottom: '8px'
              }}>
                Consent Document *
              </label>
              <input
                type="file"
                accept="image/*"
                capture="environment"
                onChange={handleLoanChange}
                // required
                style={{ 
                  width: '100%',
                  padding: '8px',
                  border: `1px solid ${COLORS.mediumGrey}`,
                  borderRadius: '6px'
                }}
              />
            </div>

            <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
              <button
                type="button"
                onClick={handleCloseDetailModal}
                style={{
                  ...buttonStyle,
                  backgroundColor: COLORS.lightGrey,
                  color: COLORS.darkText
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isUploading}
                style={{
                  ...buttonStyle,
                  backgroundColor: isUploading ? COLORS.mediumGrey : COLORS.success,
                  color: COLORS.white,
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                {isUploading ? (
                  <>
                    <div style={{ width: '16px', height: '16px', border: '2px solid #fff', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 1s linear infinite' }}></div>
                    Uploading...
                  </>
                ) : 'Upload Files'}
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  };



  const [isUploading, setIsUploading] = useState(false);

const handleDetailSubmit = async (e) => {
  e.preventDefault();
  
  // if (!photoFile || !idFile) {
  //   alert('Please select both photo and Aadhar ID files');
  //   return;
  // }

  setIsUploading(true);
  
  try {
    const formData = new FormData();
    formData.append('photo', photoFile);
    formData.append('document_file', idFile);
    formData.append('unique_patient_id', selectedDetailPatient.unique_patient_id); // Changed from patient_id
    formData.append('loan_document_file', loanFile); // Added loan ID file

    console.log('Uploading details for patient:', selectedDetailPatient.unique_patient_id);
    
    await onsiteAPI.uploadPatientDetails(formData);
    
    alert('Files uploaded successfully!');
    handleCloseDetailModal();
    
    // Refresh patient list after successful upload
    if (selectedCamp && selectedPackage) {
      await fetchPackagePatients(selectedCamp.id, selectedPackage.id);
    }
  } catch (error) {
    console.error('Error uploading files:', error);
    alert(error.message || 'Error uploading files. Please try again.');
  } finally {
    setIsUploading(false);
  }
};
  


  const renderDashboardContent = () => {
    const filteredData = data.filter(camp => camp.ready_to_go === true);
    const groupedCamps = filteredData.reduce((acc, camp) => {
      if (!acc[camp.client]) acc[camp.client] = [];
      acc[camp.client].unshift(camp);
      return acc;
    }, {});


    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
        {/* Summary cards */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '24px', marginBottom: '24px' }}>
          <div style={summaryCardStyle}>
            <h3 style={summaryCardTitle}>Total Camps</h3>
            <p style={summaryCardValueBlue}>{filteredData.length}</p>
          </div>
          <div style={summaryCardStyle}>
            <h3 style={summaryCardTitle}>Active Clients</h3>
            <p style={summaryCardValueGreen}>{Object.keys(groupedCamps).length}</p>
          </div>
        </div>


        {/* Camp List */}
        {Object.entries(groupedCamps).map(([clientId, camps]) => (
          <div key={clientId} style={clientCardStyle}>
            <div style={clientHeaderStyle}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <h2 style={clientTitleStyle}>Client: {clientId}</h2>
                  <p style={clientSubTextStyle}>{camps.length} camp{camps.length > 1 ? 's' : ''}</p>
                </div>
              </div>
            </div>


            <div style={{ padding: '24px' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                {camps.map((camp) => {
                  const status = getCampStatus(camp.start_date, camp.end_date);
                  return (
                    <div key={camp.id} style={campCardStyle}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                        <div style={{ flex: 1 }}>
                          <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '12px', marginBottom: '12px' }}>
                            <h3 style={campLocationStyle}>{camp.location}</h3>
                            <span style={{
                              ...statusBadgeStyle,
                              backgroundColor: status.status === 'Upcoming' ? '#dbeafe' :
                                status.status === 'Active' ? '#dcfce7' : '#f3f4f6',
                              color: status.status === 'Upcoming' ? '#1e40af' :
                                status.status === 'Active' ? '#166534' : '#374151'
                            }}>{status.status}</span>
                          </div>


                          <div style={campGridStyle}>
                            <div>
                              <p style={campSubText}>Location Details</p>
                              <p style={campInfo}>{camp.district}, {camp.state}</p>
                            </div>
                            <div>
                              <p style={campSubText}>Duration</p>
                              <p style={campInfo}>{formatDate(camp.start_date)} - {formatDate(camp.end_date)}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };


  // Simplified menu items
  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', color: 'text-blue-600' },
    { id: 'camp-progress', label: 'Camp Progress', color: 'text-indigo-600' },
    { id: 'logout', label: 'Log Out', color: 'text-red-600' }
  ];


  const handleMenuClick = (menuId) => {
    if (menuId === 'logout') {
      localStorage.removeItem('token');
      localStorage.removeItem('role');
      navigate('/login');
    } else {
      setActiveMenuItem(menuId);
      setSelectedCamp(null);
      setSelectedPackage(null);
      setPatients([]);
      setPackages([]);
      setSearchTerm('');
    }
  };


  return (
    <div style={{ display: 'flex', height: '100vh', backgroundColor: '#f9fafb' }}>
    {/* Modal Renders */}
    {renderDetailModal()}
    {renderAddPatientModal()}
    {renderEditPatientModal()}
    {renderScanModal()}
    
    {/* Sidebar */}
    <div style={{ width: '256px', backgroundColor: 'white', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)', borderRight: '1px solid #e5e7eb' }}>
      <div style={{ padding: '24px', borderBottom: '1px solid #e5e7eb' }}>
        <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: '#1f2937', margin: 0 }}>Onsite Coordinator</h2>
        <p style={{ fontSize: '14px', color: '#6b7280', marginTop: '4px' }}>Limited Access Dashboard</p>
      </div>
      <nav style={{ marginTop: '24px' }}>
        {menuItems.map((item) => (
          <button 
            key={item.id} 
            onClick={() => handleMenuClick(item.id)}
            style={{
              width: '100%', 
              textAlign: 'left', 
              padding: '12px 24px',
              fontSize: '18px', 
              fontWeight: '500', 
              transition: 'all 0.2s',
              border: 'none', 
              cursor: 'pointer',
              backgroundColor: activeMenuItem === item.id ? '#eff6ff' : 'transparent',
              borderRight: activeMenuItem === item.id ? '4px solid #3b82f6' : 'none',
              color: {
                'text-blue-600': '#2563eb', 
                'text-indigo-600': '#4f46e5', 
                'text-red-600': '#dc2626'
              }[item.color]
            }}
          >
            {item.label}
          </button>
        ))}
      </nav>
    </div>
    
    {/* Main Content */}
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <div style={{ backgroundColor: 'white', padding: '16px 24px', borderBottom: '1px solid #e5e7eb' }}>
        <h1 style={{ fontSize: '24px', fontWeight: 'bold', color: '#1f2937', margin: 0 }}>
          {activeMenuItem === 'dashboard' ? 'Dashboard' : 'Camp Progress'}
        </h1>
      </div>

      <div style={{ flex: 1, overflow: 'auto', padding: '24px' }}>
        {activeMenuItem === 'camp-progress' ? (
          loading ? (
            <div style={loaderContainerStyle}>
              <div style={{ textAlign: 'center' }}>
                <div style={spinnerStyle}></div>
                <p style={loadingTextStyle}>Loading camp data...</p>
              </div>
            </div>
          ) : (
            renderCampProgressContent()
          )
        ) : loading ? (
          <div style={loaderContainerStyle}>
            <div style={{ textAlign: 'center' }}>
              <div style={spinnerStyle}></div>
              <p style={loadingTextStyle}>Loading camp data...</p>
            </div>
          </div>
        ) : Array.isArray(data) && data.length > 0 ? (
          renderDashboardContent()
        ) : (
          <div style={loaderContainerStyle}>
            <div style={{ textAlign: 'center' }}>
              <div style={emptyStateIcon}></div>
              <p style={loadingTextStyle}>No camp data available</p>
            </div>
          </div>
        )}
      </div>
    </div>
  </div>
  );
};


// Style constants
const loaderContainerStyle = { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' };
const spinnerStyle = { border: '4px solid #e5e7eb', borderTop: '4px solid #3b82f6', borderRadius: '50%', width: '36px', height: '36px', animation: 'spin 1s linear infinite', margin: 'auto' };
const loadingTextStyle = { fontSize: '16px', color: '#6b7280', marginTop: '12px' };
const emptyStateIcon = { width: '40px', height: '40px', backgroundColor: '#e5e7eb', borderRadius: '50%', margin: 'auto' };
const summaryCardStyle = {
  backgroundColor: 'white', borderRadius: '8px', padding: '24px', border: '1px solid #e5e7eb',
  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
};
const summaryCardTitle = { fontSize: '14px', fontWeight: '500', color: '#6b7280', margin: 0 };
const summaryCardValueBlue = { fontSize: '24px', fontWeight: 'bold', color: '#2563eb', marginTop: '8px' };
const summaryCardValueGreen = { ...summaryCardValueBlue, color: '#16a34a' };
const clientCardStyle = { backgroundColor: 'white', borderRadius: '8px', border: '1px solid #e5e7eb', overflow: 'hidden' };
const clientHeaderStyle = { background: 'linear-gradient(to right, #3b82f6, #2563eb)', padding: '16px 24px' };
const clientTitleStyle = { fontSize: '20px', fontWeight: 'bold', color: 'white', margin: 0 };
const clientSubTextStyle = { color: '#bfdbfe', marginTop: '4px', margin: '4px 0 0 0' };
const campCardStyle = {
  border: '1px solid #e5e7eb', borderRadius: '8px', padding: '16px', transition: 'box-shadow 0.2s'
};
const campLocationStyle = { fontSize: '18px', fontWeight: '600', color: '#1f2937', margin: 0 };
const statusBadgeStyle = { padding: '2px 8px', borderRadius: '12px', fontSize: '12px', fontWeight: '500' };
const campGridStyle = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' };
const campSubText = { fontSize: '14px', color: '#6b7280', marginBottom: '4px' };
const campInfo = { fontWeight: '500', marginBottom: '4px' };
const buttonStyle = {
  padding: '10px 16px',
  border: 'none',
  borderRadius: '8px',
  fontWeight: '500',
  fontSize: '14px',
  cursor: 'pointer',
  transition: 'all 0.2s',
};


export default OnsiteDashboard;